import { environment } from "./../../environments/environment";
import { SnackbarService } from "./snackbar.service";
import { ApiService } from "./api.service";
import { Injectable } from "@angular/core";
import { fromEvent, merge, Subject } from "rxjs";

export enum StatusLoja {
  FECHADA = 0,
  ABERTA = 1,
}

@Injectable({
  providedIn: "root",
})
export class AppService {
  URL_BASE = environment.baseURL;
  _tema = "dark";
  tempoEntrega: number;
  inputTempoEntrega: number;
  statusAbertura: number;
  modalAlterarSenha: any;
  timerSound: any;
  configuracaoMonitor: any;
  _somMutado = false;
  sideBarEstaVisivel = true;
  modoMobileEstaAtivado: boolean = null;
  bottomSheetConfiguracaoEstaVisivel = false;
  cardDragDelayInMilisenconds = 500;
  onToogleBottomSheetConfig$ = new Subject<boolean>();

  onMouseMove$ = merge(fromEvent<MouseEvent>(document, "mousemove"), fromEvent<MouseEvent>(document, "touchmove"));

  constructor(private apiService: ApiService, private snackbarService: SnackbarService) {
    const stringSomMutado = sessionStorage.getItem('monitor@som-mutado') ?? 'false';
    this.somMutado = stringSomMutado === 'true';


    this.onToogleBottomSheetConfig$.subscribe((visivel) => {
      const style = visivel ? 'overflow: hidden' : 'overflow: auto';
      document.getElementsByTagName('HTML').item(0).setAttribute("style", style);
    })

    this._tema = localStorage.getItem("tema") ?? "dark";
  }

  get somMutado(): boolean {
    return this._somMutado;
  }

  set somMutado(value: boolean) {
    this._somMutado = value;
    sessionStorage.setItem('monitor@som-mutado', String(value));
  }

  get tema(): string {
    return this._tema;
  }

  set tema(value: string) {
    this._tema = value;
    localStorage.setItem("tema", value);
  }

  alterarTempoEntrega() {
    this.apiService.alterarTempoEntrega(this.inputTempoEntrega).subscribe((dados) => {
      if (dados?.status === "success" && dados?.data?.TempoEntrega) {
        this.tempoEntrega = this.inputTempoEntrega;
        this.snackbarService.Success(`Tempo de entrega alterado para ${this.inputTempoEntrega} minuto(s) com sucesso!`);
      } else {
        this.snackbarService.Error(dados.data);
      }
    });
  }

  toggleSideBar() {
    this.sideBarEstaVisivel = !this.sideBarEstaVisivel;
  }

  toggleBottomSheetConfiguracao() {
    this.bottomSheetConfiguracaoEstaVisivel = !this.bottomSheetConfiguracaoEstaVisivel;
    this.onToogleBottomSheetConfig$.next(this.bottomSheetConfiguracaoEstaVisivel);
  }

  fecharBottomSheetConfiguracao() {
    this.bottomSheetConfiguracaoEstaVisivel = false;
    this.onToogleBottomSheetConfig$.next(false);
  }

  abrirLoja() {
    this.apiService.alterarStatusAberturaLoja(StatusLoja.ABERTA).subscribe((dados) => {
      if (dados?.status === "success") {
        this.tempoEntrega = this.inputTempoEntrega ?? null;
        this.statusAbertura = Number(dados.data.StatusAbertura);
        this.snackbarService.Success(`Loja Aberta com sucesso!`);
      } else {
        this.snackbarService.Error(dados.data);
      }
    });
  }

  fecharLoja() {
    this.apiService.alterarStatusAberturaLoja(StatusLoja.FECHADA).subscribe((dados) => {
      if (dados?.status === "success") {
        this.tempoEntrega = this.inputTempoEntrega ?? null;
        this.statusAbertura = Number(dados.data.StatusAbertura);
        this.snackbarService.Success(`Loja Fechada com sucesso!`);
      } else {
        this.snackbarService.Error(dados.data);
      }
    });
  }


  stopPropagation(e: Event) {
    e.stopPropagation()
  }
}
